/**
 * PopularSlider.js — near-4-up swipeable slider, no arrows or dots
 */
import Swiper from 'swiper';

export default class PopularSlider {
  constructor(selector = '.popular-slider') {
    this.el = document.querySelector(selector);
    if (!this.el) return;

    this.swiper = new Swiper(this.el, {
      slidesPerView: 3.85,
      spaceBetween: 20,
    });
  }
}

